import { useParams } from "react-router";
import { getStudySlug } from "../helper/study";

/**
 * Resolves the active study slug for navigation/links.
 *
 * Prefers the `:study_slug` route param when present (slug-prefixed routes, e.g. the
 * authenticated `/:study_slug/tabs/...` and the multi-study `/:study_slug/welcome`),
 * and falls back to the configured/parsed slug from `getStudySlug()` when it is absent
 * (e.g. on the slug-less `/` landing in single-study mode).
 */
export function useStudySlug(): string {
  const { study_slug } = useParams<{ study_slug?: string }>();
  return study_slug ?? getStudySlug();
}
